// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1448f2c1","455":"89dc674c","977":"3b080725"}[chunkId] + ".chunk.js";
};